
































































    import Vue from "vue";
    import Component from "vue-class-component";
	
	@Component
    export default class App extends Vue {

        permitNumber: string = "";

        get isProduction() {
            return window.location.hostname === 'espay.cookcountyil.gov';
        }

        mounted(): void {
            this.permitNumber = localStorage["des.solidwaste.permit"];
        }
    }

